:host {
  overflow-x: hidden;
}
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
}

.wrapper {
  display: flex;
  height: inherit;
  width: 400px;
  flex-direction: column;
  padding: calc(var(--spacer) * 2);

  gz-title {
    margin-top: calc(var(--spacer) * 6);
  }

  .content-scrollable {
    overflow-y: auto;
    position: absolute;
    top: calc(var(--spacer) * 12);
    bottom: calc(var(--spacer) * 8);
    left: calc(var(--spacer) * 2);
    right: calc(var(--spacer) * 2);
  }

  .section:first-of-type .section-title:first-of-type {
    border-top: none;
  }

  .section {
    &-title {
      text-transform: uppercase;
      font-family: 'Montserrat SemiBold', 'Montserrat', sans-serif;
      font-weight: 600;
      font-size: 11px;
      line-height: 16.5px;
      color: var(--chart-300-icon-buttons);
      border-top: 1px solid var(--grey-layout-chart-100);
      padding-top: calc(var(--spacer) * 2);
      margin-bottom: calc(var(--spacer) * 2);
    }

    &-row {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      margin-top: calc(var(--spacer) * 2);
      margin-bottom: calc(var(--spacer) * 2);


      &-item {
        font-family: 'Montserrat Medium', 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;

        &.key {
          width: 40%;
          color: var(--chart-300-icon-buttons);
        }

        &.value {
          width: 60%;
          color: var(--body-text-arrows-400);
          padding-left: calc(var(--spacer) * 1.5);
          display: flex;
          align-items: center;
          gap: calc(var(--spacer) * 0.5);

          &.rule-triggers-wrapper {
            flex-direction: column;
            align-items: flex-start;

            #incidentsInvolvingRuleTriggers{
              display: flex;
              flex-direction: column;
            }
          }
        }
      }

      &-description {
        font-family: 'Montserrat SemiBold', 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: var(--body-text-arrows-400);
      }

      &-rule {
        width: 100%;
        margin-right: var(--spacer);
        &-header {
          display: flex;
          justify-content: space-between;
        }
        &-footer {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid var(--grey-layout-chart-100);
          padding-bottom: calc(var(--spacer) * 2);
          margin-bottom: calc(var(--spacer) * 1);
          align-items: center;
        }
        &-title {
          text-transform: uppercase;
          font-family: 'Montserrat', sans-serif;
          font-weight: 400;
          font-size: 11px;
          line-height: 16.5px;
          color: var(--body-text-arrows-400);
        }
        &-date {
          font-family: 'Montserrat', sans-serif;
          font-weight: 400;
          font-size: 12px;
          line-height: 16.5px;
          color: var(--body-text-arrows-400);
        }
        &-description {
          font-family: 'Montserrat', sans-serif;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: var(--body-text-arrows-400);
          margin: calc(var(--spacer) * 1) 0;
        }
      }

      gz-button {
        margin: 0 calc(var(--spacer) * 2) calc(var(--spacer) * 1) 0;
        &::part(button-text) {
          text-transform: none;
        }
      }
    }

    #ruleTriggers,
    #recommendations {
      color: var(--body-text-arrows-400);
    }

    #behavioralProfilesWrapper,
    #restrictedBehavioralProfilesWrapper{
      cursor: pointer;
    }
  }

  gz-button {
    position: absolute;
    bottom: calc(var(--spacer) * 2);
  }
}
